// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9e1425b4d3--wrapper--sFxg5","inner-wrapper":"_9e1425b4d3--inner-wrapper--cU2Sk"};